<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="image" class="sk__image" />
      <div class="sk__block">
        <el-skeleton-item variant="p" class="sk__name" />
        <div class="sk__block-inner">
          <el-skeleton-item variant="p" class="sk__name" />
          <el-skeleton-item variant="p" class="sk__name" />
        </div>
        <div class="sk__bottom">
          <el-skeleton-item variant="p" class="sk__button" />
          <div class="sk__bottom-inner">
            <el-skeleton-item variant="p" class="sk__tag" />
            <el-skeleton-item variant="p" class="sk__tag" />
            <el-skeleton-item variant="p" class="sk__tag" />
          </div>
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 359px;
  padding: 15px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.61);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(9.5px);

  &__image {
    width: 100%;
    height: 184px;
    border-radius: 20px 20px 0 0;
  }

  &__block {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;

    &-inner {
      width: 50%;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &__name {
    width: 100%;
    height: 25px;
  }

  &__bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-inner {
      display: flex;
      align-items: center;
      gap: 7px;
    }
  }

  &__button {
    width: 140px;
    height: 32px;
  }

  &__tag {
    border-radius: 4px;
    width: 50px;
    height: 32px;
  }
}

:deep(.el-skeleton__item) {
  --el-skeleton-color: #c9ccd0 !important;
  --el-skeleton-to-color: #c3c3c7 !important;
}
</style>